import { environment } from "../config/environment";
import { fetchJson } from "../../fetch";
import { isServer } from "../../utils";

export type PreviewMode = {
  eventKey: string;
  eventName: string;
  eventDateStart: string;
  eventDateEnd: string;
  title: string;
  highlightText: string;
  subtitleHtml: string;
  bannerHtml: string;
  gameIDs: string[];
};

export class PreviewModeService {
  public static getPreviews() {
    return fetchJson(
      `${environment.AARP_CONST_BLOB}/${environment.AARP_ENV}/json/PreviewMode.json`,
      { timeout: 10 * 1000 }
    ).catch((err) => {
      console.error(err);
      throw new Error("Unable to fetch Previews.\n" + err.stack);
    });
  }

  public static getPreviewByDateAndGameSlug(
    allPreviews: any,
    gameSlug: string
  ): PreviewMode | null {
    if (isServer) return null;

    const today = new Date().getTime();
    const selectedPreviews = allPreviews.filter((preview) => {
      const firstPreviewDate = new Date(preview.eventDateStart).setHours(
        0,
        0,
        0
      );
      const lastPreviewDate = new Date(preview.eventDateEnd).setHours(
        23,
        59,
        59
      );
      return (
        firstPreviewDate <= today &&
        lastPreviewDate >= today &&
        preview.gameIDs.some((id) => id === gameSlug)
      );
    });

    if (!selectedPreviews.length) {
      return null;
    }
    const clonedPreview = JSON.parse(JSON.stringify(selectedPreviews[0]));
    return clonedPreview;
  }
}
